// extracted by mini-css-extract-plugin
export default {"artworkWrapper":"Prepayments_artworkWrapper__6bsjw","selectArtwork":"Prepayments_selectArtwork__3Idgq"};